<template>
  <div v-if="visible" :class="containClass" class="missing-page" :style="styles">
    <slot name="message">
      <span :class="messageClass">{{message}}</span>
    </slot>
  </div>
</template>

<script>
  import { missingPagesKeys, missingPages } from '../../libs/const'

  export default {
    name: 'missingPage',
    components: {},
    props: {
      visible: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        validator (value) {
          return missingPagesKeys.includes(value)
        },
        default: missingPagesKeys[0]
      },
      containClass: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      },
      messageClass: {
        type: String,
        default: ''
      }
    },
    data () {
      return {}
    },
    mounted () {},
    methods: {},
    computed: {
      pageUrl () {
        let path = missingPages.get(this.type).path
        return `../../static/images/missingPages/${path}`
      },
      styles () {
        return {
          // TODO: 为什么会渲染出2个center？
          background: `url(${this.pageUrl}) no-repeat center / contain`
        }
      }
    },
    watch: {}
  }
</script>

<style lang="less" scoped>
  .missing-page {
    width: 100%;
    height: 100%;
    //width: 892px;
    //height: 728px;
    //transform: scale(0.5, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/views/components/missing-page.vue